// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GoodlokAuthForm_wrapper__t_mYz","logo":"GoodlokAuthForm_logo__GpqHS","view_webview":"GoodlokAuthForm_view_webview__wcygg"};